import { EnumLanguage } from '@libs/constants';


/**------------------------------------------------------
 * Marketplace Definitions
 */
export enum EnumAmazonMarketplace {
	All 		= 'all_markets',
	COM 		= 'com',
	CO_UK 		= 'co_uk',
	DE 			= 'de',
	FR 			= 'fr',
	IT 			= 'it',
	ES 			= 'es',
	JP 			= 'jp',

	// not used in mba
	NL 			= 'nl',			// Netherlands
	PL 			= 'pl',			// Poland
	SE 			= 'se',			// Sweden
	CA 			= 'ca',			// Canada
	AU 			= 'au',			// Australia
	MX 			= 'mx'			// Mexico
}


/**------------------------------------------------------
 * Product & Sorting Configurations
 */
export enum EnumAmazonProduct {
	All 							= 'all_products',
	Shirt 							= 'shirt',
	PremiumShirt 					= 'premium_shirt',
	ComfortColorsHeavyweightTShirt 	= 'comfort_colors_heavyweight_tshirt',
	VNeck 							= 'vneck',
	TankTop 						= 'tank_top',
	LongSleeve 						= 'long_sleeve',
	Raglan 							= 'raglan',
	Sweatshirt 						= 'sweatshirt',
	ComfortColorsSweatshirt 		= 'comfort_colors_sweatshirt',
	ComfortColorsCropSweatshirt 	= 'comfort_colors_crop_sweatshirt',
	CropTop							= 'crop_top',
	Hoodie 							= 'hoodie',
	PerformanceHoodie				= 'performance_hoodie',
	PerformanceShirt 				= 'performance_shirt',
	PerformancePolo 				= 'performance_polo',
	BaseballHat 					= 'baseball_hat',
	TruckerHat 						= 'trucker_hat',
	SportSunVisor 					= 'sport_sun_visor',
	PerformanceQuarterZip 			= 'performance_quarter_zip',
	PopSocket 						= 'popsockets',
	PhoneCase 						= 'phone_cases',
	ToteBag 						= 'tote_bag',
	ThrowPillow 					= 'throw_pillow',
	Tumbler 						= 'tumbler',
	CeramicMug 						= 'ceramic_mug',
	WaterBottle 					= 'water_bottle',
	SportBackpack					= 'sport_backpack',
	HardcoverJournal				= 'hardcover_journal',
	ZipHoodie 						= 'zip_hoodie',
	LaptopSleeve 					= 'laptop_sleeve',
	MousePad 						= 'mouse_pad',
	ThrowBlanket 					= 'throw_blanket',
	UnframedPoster 					= 'unframed_poster',
	TravelTumbler 					= 'travel_tumbler',
	RetractablePen 					= 'retractable_pen',
	KDP 							= 'kdp'
}

export enum EnumAmazonSorting {
	Featured 	= 'featured',
	PriceAsc 	= 'price_asc',
	PriceDesc 	= 'price_desc',
	ReviewDesc 	= 'review_desc',
	Newest 		= 'newest'
}

export enum EnumAmazonCategory {
	All 		= 'all',
	Clothing 	= 'clothing',
	Book	 	= 'book'
}


/**------------------------------------------------------
 * Product Category Definitions
 */
export enum EnumAmazonFulfillmentType {
	MBA 		= 'mba',
	KDP 		= 'kdp',
	FBA 		= 'fba'
}


/**------------------------------------------------------
 * Fit Types
 */
export enum EnumAmazonFitType {
	Men 		= 'men',
	Women 		= 'women',
	Youth 		= 'youth',
	Unisex 		= 'unisex'
}


/**------------------------------------------------------
 * Colors
 */
export enum EnumAmazonColor {
	Asphalt 			= 'asphalt',
	BabyBlue 			= 'baby_blue',
	Black 				= 'black',
	Brown 				= 'brown',
	Cranberry 			= 'cranberry',
	DarkHeather 		= 'dark_heather',
	ForestGreen 		= 'forest_green',
	Grass 				= 'grass',
	HeatherBlue 		= 'heather_blue',
	HeatherGrey 		= 'heather_grey',
	KellyGreen 			= 'kelly_green',
	Lemon 				= 'lemon',
	Navy 				= 'navy',
	Olive 				= 'olive',
	Orange 				= 'orange',
	Pink 				= 'pink',
	NeonPink 			= 'neon_pink',
	Purple 				= 'purple',
	Red 				= 'red',
	Sapphire 			= 'sapphire',
	Royal 				= 'royal',
	Silver 				= 'silver',
	Slate 				= 'slate',
	White 				= 'white',
	BlackWhite 			= 'black_white',
	NavyWhite 			= 'navy_white',
	RedWhite 			= 'red_white',
	RoyalBlueWhite 		= 'royal_blue_white',
	BlackAthleticHeather = 'black_athletic_heather',
	DarkHeatherWhite 	= 'dark_heather_white',
	NavyAthleticHeather = 'navy_athletic_heather',
	PinkHeather  		= 'pink_heather',
	PurpleHeather  		= 'purple_heather',
	BrightBlueHeather  	= 'bright_blue_heather',
	OliveHeather  		= 'olive_heather',
	RedHeather  		= 'red_heather',
	SapphireBlue  		= 'sapphire_blue',
	Burgundy  			= 'burgundy',
	SageGreen  			= 'sage_green',
	GoldenYellow		= 'golden_yellow',
	DustyBlue			= 'dusty_blue'
}


/**------------------------------------------------------
 * Mapping
 */
// eslint-disable-next-line @typescript-eslint/typedef
export const AMAZON_MARKETPLACE_LANGUAGES_CODES = {
	[EnumAmazonMarketplace.All]		: EnumLanguage.EN,
	[EnumAmazonMarketplace.COM]		: EnumLanguage.EN,
	[EnumAmazonMarketplace.CO_UK]	: EnumLanguage.EN,
	[EnumAmazonMarketplace.DE]		: EnumLanguage.DE,
	[EnumAmazonMarketplace.FR]		: EnumLanguage.FR,
	[EnumAmazonMarketplace.IT]		: EnumLanguage.IT,
	[EnumAmazonMarketplace.ES]		: EnumLanguage.ES,
	[EnumAmazonMarketplace.JP]		: EnumLanguage.JA,

	[EnumAmazonMarketplace.NL]		: EnumLanguage.NL,
	[EnumAmazonMarketplace.PL]		: EnumLanguage.PL,
	[EnumAmazonMarketplace.SE]		: EnumLanguage.SV,
	[EnumAmazonMarketplace.CA]		: EnumLanguage.EN,
	[EnumAmazonMarketplace.AU]		: EnumLanguage.EN,
	[EnumAmazonMarketplace.MX]		: EnumLanguage.ES
};

// eslint-disable-next-line @typescript-eslint/typedef
export const AMAZON_NAME_MAPPINGS = {
	[EnumAmazonMarketplace.All]		: 'All Marketplaces',
	[EnumAmazonMarketplace.COM]		: 'COM - United States',
	[EnumAmazonMarketplace.CO_UK]	: 'CO.UK - United Kingdom',
	[EnumAmazonMarketplace.DE]		: 'DE - Germany',
	[EnumAmazonMarketplace.FR]		: 'FR - France',
	[EnumAmazonMarketplace.IT]		: 'IT - Italy',
	[EnumAmazonMarketplace.ES]		: 'ES - Spain',
	[EnumAmazonMarketplace.JP]		: 'JP - Japan',

	[EnumAmazonMarketplace.NL]		: 'NL - Netherlands',
	[EnumAmazonMarketplace.PL]		: 'PL - Poland',
	[EnumAmazonMarketplace.SE]		: 'SE - Sweden',
	[EnumAmazonMarketplace.CA]		: 'CA - Canada',
	[EnumAmazonMarketplace.AU]		: 'AU - Australia',
	[EnumAmazonMarketplace.MX]		: 'MX - Mexico',

	[EnumAmazonProduct.All]			: 'All Products',
	[EnumAmazonProduct.Shirt]		: 'T-Shirt',
	[EnumAmazonProduct.Hoodie]		: 'Hoodie',
	[EnumAmazonProduct.PerformanceHoodie]: 'Performance Hoodie',
	[EnumAmazonProduct.CropTop]		: 'Crop Top',
	[EnumAmazonProduct.PerformanceShirt]: 'Performance Shirt',
	[EnumAmazonProduct.PerformancePolo]: 'Performance Polo',
	[EnumAmazonProduct.BaseballHat]	: 'Baseball Hat',
	[EnumAmazonProduct.TruckerHat]	: 'Trucker Hat',
	[EnumAmazonProduct.PerformanceQuarterZip]: 'Performance Quarter Zip',
	[EnumAmazonProduct.PopSocket]	: 'PopSockets',
	[EnumAmazonProduct.PhoneCase]	: 'Phone Case',
	[EnumAmazonProduct.KDP]			: 'KDP',

	[EnumAmazonProduct.PremiumShirt]: 'Premium Shirt',
	[EnumAmazonProduct.ComfortColorsHeavyweightTShirt]: 'Comfort Colors Heavyweight T-Shirt',
	[EnumAmazonProduct.VNeck]		: 'V-Neck',
	[EnumAmazonProduct.TankTop]		: 'Tank Top',
	[EnumAmazonProduct.LongSleeve]	: 'Long Sleeve',
	[EnumAmazonProduct.Raglan]		: 'Raglan',
	[EnumAmazonProduct.Sweatshirt]	: 'Sweatshirt',
	[EnumAmazonProduct.ComfortColorsSweatshirt]: 'Comfort Colors Sweatshirt',
	[EnumAmazonProduct.ComfortColorsCropSweatshirt]: 'Comfort Colors Crop Sweatshirt',
	[EnumAmazonProduct.ToteBag]		: 'Tote Bag',
	[EnumAmazonProduct.ThrowPillow]	: 'Throw Pillow',
	[EnumAmazonProduct.Tumbler]		: 'Tumbler',
	[EnumAmazonProduct.CeramicMug]	: 'Ceramic Mug',
	[EnumAmazonProduct.WaterBottle]	: 'Water Bottle',
	[EnumAmazonProduct.SportSunVisor]: 'Sport Sun Visor',
	[EnumAmazonProduct.SportBackpack]: 'Sport Backpack',
	[EnumAmazonProduct.HardcoverJournal]: 'Hardcover Journal',

	[EnumAmazonSorting.Featured]	: 'Featured',
	[EnumAmazonSorting.PriceAsc]	: 'Price: Low to High',
	[EnumAmazonSorting.PriceDesc]	: 'Price: High to Low',
	[EnumAmazonSorting.ReviewDesc]	: 'Reviews',
	[EnumAmazonSorting.Newest]		: 'Newest',
	[EnumAmazonProduct.ZipHoodie]	: 'Zip Hoodie',
	[EnumAmazonProduct.LaptopSleeve]: 'Laptop Sleeve',
	[EnumAmazonProduct.MousePad]	: 'Mouse Pad',
	[EnumAmazonProduct.ThrowBlanket]: 'Throw Blanket',
	[EnumAmazonProduct.UnframedPoster]: 'Unframed Poster',
	[EnumAmazonProduct.TravelTumbler]: 'Stainless Steel Travel Tumbler',
	[EnumAmazonProduct.RetractablePen]: '12-Pack Retractable Pens'
};
